import React, { useRef, useEffect, useState } from 'react';
import axios from 'axios';
import './form.css';
import { ChakraProvider, theme } from '@chakra-ui/react'
import {
    useJsApiLoader,
    GoogleMap,
    Autocomplete
} from '@react-google-maps/api';

import {
    Box,
    Button,
    ButtonGroup,
    Flex,
    HStack,
    IconButton,
    Input,
    SkeletonText,
    Text,
    Image,
    InputGroup,
    InputRightElement,
    Stack,
    Container
} from '@chakra-ui/react';

import locicon from './image/map pointer.png'


const libraries = ['places', 'drawing', 'geometry'];

const Form = () => {
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: libraries,
    });

    /* const [region, setRegion] = useState(null);
    const [countryname, setCountryName] = useState(null); */

    const handleGetCurrentLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const currentLocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };

                axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${currentLocation.lat},${currentLocation.lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`)
                    .then((res) => {
                        const currentAddress = res.data.results[0].formatted_address;
                        console.log(currentAddress);

                        // Set the input field value with the current location
                        sourceRef.current.value = currentAddress;
                    })
                    .catch((error) => {
                        console.error("Error fetching geocode information:", error);
                    });
            });
        } else {
            alert("Geolocation is not supported by this browser.");
        }
    };


    const sourceRef = useRef(null);
    const destinationRef = useRef(null);



    const parisBound = {
        north: 48.9021,
        south: 48.8156,
        east: 2.4699,
        west: 2.2241
    };

    const nyBound = {
        north: 40.9176,
        south: 40.4774,
        east: -73.7004,
        west: -74.2591
    };
    /*
        const getUserLocation = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    position => {
                        const { latitude, longitude } = position.coords;
                        // Check if user is in New York
                        if (latitude >= nyBound.south && latitude <= nyBound.north && longitude >= nyBound.west && longitude <= nyBound.east) {
                            setRegion(nyBound);
                            setCountryName('us');
                        } else {
                            setRegion(parisBound);
                            setCountryName('fr');
                        }
                        console.log('User location:', region);
                    },
                    error => {
                        console.error('Error getting user location:', error);
                        // Default to Paris if location cannot be determined
                        setRegion(parisBound);
                        setCountryName('fr');
                    }
                );
            } else {
                console.error('Geolocation is not supported by this browser.');
                // Default to Paris if geolocation is not supported
                setRegion(parisBound);
                setCountryName('fr');
            }
        };
    
        useEffect(() => {
            getUserLocation();
        }, []); */

    const handleSubmit = (event) => {
        event.preventDefault();
        const sourceValue = sourceRef.current.value;
        const destinationValue = destinationRef.current.value;
        if (!sourceValue || !destinationValue) {
            alert('Please enter both source and destination.');
            return;
        }

        // Prepare the data to be sent to the parent window
        const formData = {
            source: sourceValue,
            destination: destinationValue
        };

        // Send the form data to the parent window
        window.parent.postMessage(formData, '*');

        /*  const url = `https://bat-crocodile-r56y.squarespace.com/drive-smart-with-dencity?source=${encodeURIComponent(sourceValue)}&destination=${encodeURIComponent(destinationValue)}`;
         window.location.href = url; */
    };

    if (!isLoaded) {
        // Return a loading indicator or null while Google Maps is loading
        return <SkeletonText></SkeletonText>;
    }

    return (
        <main style={{ backgroundColor: 'white', width: '100%', minWidth: '450px', height: '160px' }}>
            <ChakraProvider>
                <div className='formdiv'>
                    <form onSubmit={handleSubmit}>
                        {isLoaded && (

                            <Stack spacing={2} >
                                <Autocomplete
                                    /* bounds={{
                                        north: 48.9021,
                                        south: 48.8156,
                                        east: 2.4699,
                                        west: 2.2241
                                    }} */

                                    onLoad={(autocomplete) => {
                                        autocomplete.setComponentRestrictions({
                                            country: ['fr', 'us'],
                                        }, { strictBounds: true, }
                                        );
                                        autocomplete.setBounds(nyBound);
                                        autocomplete.setBounds(parisBound);
                                    }}
                                >
                                    <InputGroup >
                                        <Input ref={sourceRef} type="text" name="source" id="source" placeholder="Enter Location" required size='md' />
                                        <InputRightElement>
                                            <IconButton
                                                aria-label="Current Location"
                                                icon={<img src={locicon} width={10} />}
                                                variant="ghost"
                                                _hover={{ color: 'black' }}
                                                _focus={{ color: 'black' }}
                                                _active={{ color: 'black' }}
                                                onClick={handleGetCurrentLocation}
                                            />
                                        </InputRightElement>
                                    </InputGroup>
                                </Autocomplete>
                                <Autocomplete
                                    onLoad={(autocomplete) => {
                                        autocomplete.setComponentRestrictions({
                                            country: ['fr', 'us'],
                                        }, { strictBounds: true, }
                                        );
                                        autocomplete.setBounds(nyBound);
                                        autocomplete.setBounds(parisBound);
                                    }}
                                /* options={{
                                    componentRestrictions: { country: countryname },
                                    strictBounds: true,
                                    bounds: region,
                                }} */
                                >

                                    <Input ref={destinationRef} type="text" name="destination" id="destination" placeholder="Enter Destination" required size='md' />
                                </Autocomplete>

                                {/* <Button w={150} color={'white'} backgroundColor={'black'} _active={{ backgroundColor: 'none' }} _hover={{ backgroundColor: 'none' }} type="submit">Find Route</Button> */}

                                <button className='formbtn' type='submit'>Find Route</button>
                            </Stack>

                        )}
                    </form>
                </div>
            </ChakraProvider >
        </main>
    );
}

export default Form;
